import { Checkbox } from '@mui/material';

import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

type TableHeaderBulkSelectCheckboxProps = Pick<
  ReturnType<typeof useBulkSelect>,
  'bulkSelectedItems' | 'handleBulkSelectMultiple'
> & {
  currentPageItems: string[];
};

export const TableHeaderBulkSelectCheckbox: React.FC<TableHeaderBulkSelectCheckboxProps> = ({
  bulkSelectedItems,
  handleBulkSelectMultiple,
  currentPageItems,
}) => {
  const getCurrentPageSelectedItems = (currentPageItems: string[]): string[] =>
    currentPageItems.filter((item) => bulkSelectedItems.has(item));

  const currentPageSelectedItems = getCurrentPageSelectedItems(currentPageItems);
  const indeterminate =
    currentPageSelectedItems.length && currentPageSelectedItems.length < currentPageItems.length;
  const checked = currentPageSelectedItems.length === currentPageItems.length;

  return (
    <Checkbox
      color='primary'
      indeterminate={!!indeterminate}
      checked={checked}
      onChange={() => {
        handleBulkSelectMultiple(currentPageItems, currentPageSelectedItems);
      }}
      inputProps={{
        'aria-label': 'select all',
      }}
    />
  );
};
